// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmNewChatModal__fCfku {
  width: 372px;
  height: 292px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--tables-primary-row-surface-default);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.modalBody__EW3yW {
  padding: 25px;
}

.modalBodyTitle__dW71X {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  color: var(--header-title-main);
  text-align: center;
  text-transform: uppercase;
}

.modalBodyConfirmText__DoFz8 {
  font-size: 14px;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  margin-top: 25px;
}

.modalFooter__UHUo3 {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
  padding: 0 25px 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/ChatComponent/components/ConfirmNewChatModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,2DAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AAzEF;;AA4EA;EACE,aAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.confirmNewChatModal {\n  width: 372px;\n  height: 292px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: var(--tables-primary-row-surface-default);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n}\n\n.modalBody {\n  padding: 25px;\n}\n\n.modalBodyTitle {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--header-title-main);\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.modalBodyConfirmText {\n  font-size: 14px;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  margin-top: 25px;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  column-gap: 10px;\n  padding: 0 25px 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmNewChatModal": `confirmNewChatModal__fCfku`,
	"modalBody": `modalBody__EW3yW`,
	"modalBodyTitle": `modalBodyTitle__dW71X`,
	"modalBodyConfirmText": `modalBodyConfirmText__DoFz8`,
	"modalFooter": `modalFooter__UHUo3`
};
module.exports = ___CSS_LOADER_EXPORT___;
